import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  hostedVideoActions,
  EmbedData
} from '../../../../../../store/modules/hostedVideo';
import { useEmbedSizes } from '../hooks';

export type Sizes = {
  width: number;
  height: number;
};

export const useVideoSizes = ({ sizes: initialSizes, sizeType }: EmbedData) => {
  const dispatch = useDispatch();
  const embedSizes = useEmbedSizes(initialSizes);
  const [sizes, setSizes] = useState(embedSizes);
  const [selectedSizeType, setSelectedSizeType] = useState(sizeType);

  useEffect(() => {
    if (
      !sizes ||
      (sizes?.width === initialSizes?.width &&
        sizes?.height === initialSizes?.height)
    ) {
      return;
    }

    dispatch(hostedVideoActions.updateEmbedSizes({ ...sizes }));
  }, [sizes?.width, sizes?.height]);

  useEffect(() => {
    if (!selectedSizeType || selectedSizeType === sizeType) return;

    dispatch(hostedVideoActions.updateEmbedSizeType(selectedSizeType));
  }, [selectedSizeType]);

  return [sizes, setSizes, selectedSizeType, setSelectedSizeType] as const;
};
